export const getPredictorFeatureDefinitionForFilters = <
  T extends { catalog_id?: string | number | null },
>(
  features: readonly T[] | null | undefined,
): T | undefined => features?.find((feature) => feature.catalog_id == null);
